export const qualificationsData = {
    education: [
      {
        title: "Study of Computer Science",
        subtitle: "At 10th of Ramadan Institute",
        calendar: "2020",
      },
      {
        title: "Front End Developer Training",
        subtitle: "At Egyptian Center for Technology",
        calendar: "2021",
      },
      {
        title: "Study of Computer Science",
        subtitle: "At 10th of Ramadan Institute",
        calendar: "Still to 2024",
      },
    ],

    // ==============================================

    experience: [
      {
        title: "Bisic Web",
        subtitle: "Self study",
        calendar: "2021",
      },
      {
        title: "Programming Fundamentals",
        subtitle: "TG Academy",
        calendar: "2022",
      },
      {
        title: "Study Front-End Development",
        subtitle: "Study & Implementation",
        calendar: "2023",
      },
      {
        title: "Study Back-End Development",
        subtitle: "Study & Implementation",
        calendar: "2023",
      },
      {
        title: "Create Projects",
        subtitle: "To increase experience",
        calendar: "2023 - to now",
      },
      {
        title: "App development using JavaScript",
        subtitle: "Hassoub Academy",
        calendar: "2024 - to now",
      },
    ],
  };
  